import { Ref, ComputedRef, isRef } from "vue";
import { computed } from "vue";

/**
 * @function usePrioritizeValues - returns the name of the first true flag
 * @param {string} defaultValue - the default name in case nothing is true
 * @param {{ [propName: string]: Ref<boolean | undefined> | boolean | undefined}[]}values - the values in order of priority
 * @returns {ComputedRef<boolean>} - the name of the prioritized value
 */
export default function usePrioritizeFlags(
  defaultValue: string,
  ...values: {
    [propName: string]: Ref<boolean | undefined> | boolean | undefined;
  }[]
): ComputedRef<string> {
  const value = computed(() => {
    //initialize with the default value
    let theValue = defaultValue;
    //check for every value in values
    for (const oneValue of values) {
      //get the key name
      const key = Object.keys(oneValue)[0];
      const keyValue = oneValue[key];
      if (isRef(keyValue)) {
        //if the value is true assign the key name and break the loop
        if (keyValue.value) {
          theValue = key;
          break;
        }
      } else {
        if (keyValue) {
          theValue = key;
          break;
        }
      }
    }
    //return the obtained value
    return theValue;
  });

  return value;
}
